// WEB-471 — mirrors backend/src/users/enums/system-role.enum.ts (SystemRole.ADMIN).
// The DB enum `system_role_enum` is UPPERCASE ('USER','ADMIN'); GET /auth/me
// returns systemRole as that raw string, so the FE constant must be 'ADMIN'
// (was 'admin' — a casing drift that never matched the DB, so no admin was ever
// recognized on the FE either).
export const SYSTEM_ROLE_ADMIN = 'ADMIN';
